import OpenExcelUniversal from "../../../../components/excel/OpenExcelUniversal"
import { SecaoButao } from "../../../../components/formulario/styled"
import SearchInput from "../../../../components/inputs/searchInput"
import ModalExportar from "../../../../components/modalExportar"
import DonwloadPdf from "../../../../components/pdf/DonwloadPdf"
import { useAcolherVisitantes } from "../context/getAcolher"


const HeaderVisitante = () => {
  const { listAll, getSearchNome } = useAcolherVisitantes();

  return (
    <SecaoButao style={{ marginBottom: 5 }}>
      <section style={{ display: 'flex', gap: 5 }}>
        <ModalExportar
          callDownloadExcel={() => OpenExcelUniversal(listAll, ["nome", "email", "telefone"])}
          callDownloadPdf={() => DonwloadPdf(listAll, ["Nome", "Email", "Telefone"],
            ["nome", "email", "telefone"], listAll?.length, [], `${listAll?.length}`)
          }
        />
      </section>
      <SearchInput placeholder="Procure por nome" onChange={getSearchNome} />
      <section />
    </SecaoButao>
  )
}

export default HeaderVisitante;
